import { NgIf } from '@angular/common';
import { Component, OnInit, Output, EventEmitter, ElementRef, ViewChild, Input, OnDestroy } from '@angular/core';

@Component({
    selector: 'infinite-scroll',
    templateUrl: './custom-infinite-scroll.component.html',
    styleUrls: ['./custom-infinite-scroll.component.scss'],
    standalone: true,
    imports: [
        NgIf
    ]
})
export class InfiniteScrollComponent implements OnInit, OnDestroy {
    @Input() options = {};
    @Input() downScroll = true;
    @Output() scrolled = new EventEmitter();
    @ViewChild('anchor') anchor: ElementRef<HTMLElement>;

    private observer: IntersectionObserver;

    constructor(private host: ElementRef) { }

    get element() {
        return this.host.nativeElement;
    }

    ngOnInit() {
        const options = {
            root: this.isHostScrollable() ? this.host.nativeElement : null,
            ...this.options
        };

        this.observer = new IntersectionObserver(([entry]) => {
            entry.isIntersecting && this.scrolled.emit();
        }, options);


    }

    ngAfterViewInit() {
        this.observer.observe(this.anchor.nativeElement);
    }

    private isHostScrollable() {
        const style = window.getComputedStyle(this.element);

        return style.getPropertyValue('overflow') === 'auto' ||
            style.getPropertyValue('overflow-y') === 'scroll';
    }

    ngOnDestroy() {
        this.observer.disconnect();
    }

}
